import React from 'react';
import PropTypes from 'prop-types';
import FlatButton from 'material-ui/FlatButton';
import PrevIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-left';
import NextIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-right';
import { colors } from '../../../lib/styles';
import './pagination.css';

const propTypes = {
	// Смена страницы
	changePage: PropTypes.func.isRequired,
	// Общее количество страниц
	totalPage: PropTypes.number.isRequired,
	// Текущая страница
	currentPage: PropTypes.number.isRequired,
	// Количество отображаемых страниц
	pageList: PropTypes.number,
};

const defaultProps = {
	pageList: 2,
};

const styles = {
	footer: {
		width: '100%',
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'flex-end',
	},

	button: {
		minWidth: 87,
		textAlign: 'center',
		color: '#46bc98',
	},

	active: {
		minWidth: 87,
		color: '#000',
	},

	buttonHover: 'transparent',
};

/**
 * Определяем и устанавливаем диапазон номеров страниц, которые будут видны
 * @param {Number} currentPage номер текущей страницы
 * @param {Number} pageList количество отображаемых страниц
 * @param {Number} totalPages общее количество страниц
 * @returns {{currentPage: number, totalPages: *, startPage: *, endPage: *, pages: Array}}
 */
const getPager = (currentPage = 1, pageList, totalPages) => {
	let startPage;
	let endPage;
	const medianPageNumber = parseInt(pageList / 2, 10);

	if (totalPages <= pageList) {
		startPage = 1;
		endPage = totalPages;
	} else if (currentPage <= medianPageNumber) {
		startPage = 1;
		endPage = pageList;
	} else if (currentPage + medianPageNumber >= totalPages) {
		startPage = totalPages - pageList;
		endPage = totalPages;
	} else {
		startPage = currentPage - medianPageNumber;
		endPage = currentPage + medianPageNumber;
	}

	const pages = [];
	for (let i = startPage; i < endPage + 1; i += 1) {
		pages.push(i);
	}
	return {
		currentPage,
		totalPages,
		startPage,
		endPage,
		pages,
	};
};

const pointButton = () => {
	return <span style={{ ...styles.button, minWidth: 49 }}>...</span>;
};

const Pagination = ({ totalPage, currentPage, changePage, pageList }) => {
	if (totalPage <= 1) {
		return <div />;
	}
	const pager = getPager(currentPage, pageList, totalPage);
	return (
		<footer style={styles.footer}>
			{currentPage !== 1 && (
				<FlatButton
					className="pagination--btn"
					primary={true}
					style={styles.button}
					hoverColor={styles.buttonHover}
					labelStyle={{ textTransform: 'lowercase' }}
					onClick={() => changePage(currentPage - 1)}
					label="назад"
					icon={<PrevIcon color="#46bc98" style={{ marginLeft: 1 }} hoverColor={colors.link} />}
				/>
			)}
			<FlatButton
				className="pagination--btn"
				style={currentPage === 1 ? styles.active : styles.button}
				hoverColor={styles.buttonHover}
				primary={true}
				onClick={() => changePage(1)}
				label="1"
				disabled={currentPage === 1}
			/>
			{pager.startPage - 1 > 1 && pointButton()}
			{pager.pages.map((page, index) => {
				const isCurrentPageNumber = currentPage === page;
				if (page !== 1 && page !== totalPage) {
					return (
						<FlatButton
							className="pagination--btn"
							key={index}
							style={isCurrentPageNumber ? styles.active : styles.button}
							hoverColor={styles.buttonHover}
							primary={true}
							onClick={() => changePage(page)}
							disabled={isCurrentPageNumber}
							label={page}
						/>
					);
				}
				return null;
			})}
			{pager.endPage + 1 < totalPage && pointButton()}
			<FlatButton
				className="pagination--btn"
				style={currentPage === totalPage ? styles.active : styles.button}
				hoverColor={styles.buttonHover}
				primary={true}
				onClick={() => changePage(totalPage)}
				label={totalPage}
				disabled={currentPage === totalPage}
			/>
			{currentPage !== totalPage && (
				<FlatButton
					className="pagination--btn"
					style={styles.button}
					hoverColor={styles.buttonHover}
					labelStyle={{ textTransform: 'lowercase' }}
					primary={true}
					labelPosition="before"
					onClick={() => changePage(currentPage + 1)}
					label="дальше"
					icon={<NextIcon color="#46bc98" style={{ marginRight: 1 }} hoverColor={colors.link} />}
				/>
			)}
		</footer>
	);
};

Pagination.propTypes = propTypes;

Pagination.defaultProps = defaultProps;

export default Pagination;



// WEBPACK FOOTER //
// src/components/controls/pagination/pagination.js